import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RegistrationPayload, RegistrationService, TenantInfo } from '../registration.service';
import { MatButton } from '@angular/material/button';
import { applyRegistrationValidationError } from '../registration-validation';

type Step = 'tenantInfo' | 'solutionInfo'

interface Status {
  loading: boolean
}

@Component({
    selector: 'app-mkpl-onboarding',
    templateUrl: './mkpl-onboarding.component.html',
    styleUrls: ['./mkpl-onboarding.component.css'],
    standalone: false
})
export class MkplOnboardingComponent implements OnInit {
  private currentStepBs: BehaviorSubject<Step> = new BehaviorSubject<Step>('tenantInfo');
  public currentStep$: Observable<Step> = this.currentStepBs.asObservable();
  private mkplId: string = '';
  public status: Status = { loading: false };

  public userForm!: FormGroup;

  constructor(private _fb: FormBuilder,
    private _route: ActivatedRoute,
    private _router: Router,
    private _snackbar: MatSnackBar,
    private _registrationService: RegistrationService,
    private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.userForm = this._fb.group({
      tenantInfo: null,
      solutionInfo: null
    });
    this.mkplId = this._route.snapshot.queryParams['x-amzn-marketplace-token'];
    this._registrationService.validateToken(this.mkplId).subscribe({
      next: (response: any) => {
        console.log(response);
        if (!response.can_register) {
          this._snackbar.open("Customer already registered.", "FAIL")
          this._router.navigate(['/thanks']);
        }
  }})}

  subformInitialized(name: string, group: FormGroup) {
    this.userForm.setControl(name, group);
    this.cdr.detectChanges();
  }

  submitForm() {
    const formValues = this.userForm.getRawValue();
    const payload = this.buildPayload(formValues, this.mkplId);

    this.status.loading = true;
    this._registrationService.register(payload).subscribe({
      next: () => {
        this._snackbar.open("Registration Successful", "OK");
        const tenantInfo = formValues?.tenantInfo;
        const tenantId = tenantInfo?.tenantName;
        this._router.navigate(['/atlas-signup'], {
          queryParams: tenantId ? { tenantId, step: 'subscription' } : { step: 'subscription' },
          state: tenantInfo ? { tenantInfo } : undefined,
        });
      },
      error: (err) => {
        const reason = applyRegistrationValidationError(this.userForm, err);
        this._snackbar.open("Registration Failed: " + reason, "FAIL");
        this.status.loading = false;
      },
    });
  }

  buildPayload(formValues: any, mkplId: string): RegistrationPayload {
    return {
      tenantInfo: formValues.tenantInfo,
      solutionInfo: formValues.solutionInfo,
      registrationInfo: {
        provider: "aws_marketplace",
        provider_interface_id: mkplId
      }
    }
  }


}
